// A feed is flagged as having an issue when either:
//  - the server has already given up on it (feedStatus 'BAD') — e.g. broken for the full grace
//    period, or structurally broken such as declaring localhost links; or
//  - it has failed to fetch at least twice in a row for longer than 12h — long enough to rule
//    out a transient hiccup while still surfacing genuinely broken feeds early.
const MIN_ERRORS = 2;
const MIN_FAILING_MS = 12 * 60 * 60 * 1000;

export interface FeedIssueInfo {
  feedStatus?: string;
  fetchErrorCount?: number;
  fetchFailingSinceAt?: string;
}

export const hasFeedIssue = (feed?: FeedIssueInfo): boolean => {
  if (!feed) return false;
  if (feed.feedStatus == 'BAD') return true;
  if (!feed.fetchFailingSinceAt || (feed.fetchErrorCount ?? 0) < MIN_ERRORS) return false;
  const since = Date.parse(feed.fetchFailingSinceAt);
  return !isNaN(since) && Date.now() - since > MIN_FAILING_MS;
};
